// The `dictation/logs` family's ONLY contribution to this slice, and it lands
// here because the birth said it would: `invalidateDictationLogsStats` was held
// back from `/contracts` at ARCFE-1043 (it is a cache COMMAND over an injected
// `QueryClient`, and `/contracts` is the inert zone), with the recorded plan
// "lands in `/data` at D1". This is that D1.
//
// It is the one logs-family data module the t11nClient split does not govern.
// Measured at ARCFE-1067: every other file in that family's surface —
// `useDictationLogs`, `useDictationLogsStats`, `useMutationDeleteDictationLog`,
// `useMutationDeleteDictationLogs` — imports the t11n api fns BY VALUE and is
// therefore an owned exclusion until scribe-pod rules the split. This module
// imports a key and a type. Its reach to t11nClient measured `false` before the
// move, the only file in either family for which that was already true.
//
// Moved from `src/features/dictationLogs/hooks/dictationLogsQueryKey.ts`, which
// keeps re-exporting it name-intact — `createDictationSlice.ts` and
// `DictationLogsContent.tsx` import it from there, and
// `DictationLogsContent.test.tsx` `jest.mock`s that exact path, so the
// interception point is preserved.
import type { QueryClient } from '@tanstack/react-query';

import { DICTATION_LOGS_STATS_KEY } from '../contracts';

// Own module so the dictation Zustand slice can invalidate without importing t11nClient.
export function invalidateDictationLogsStats(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: [DICTATION_LOGS_STATS_KEY] });
}
